import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import {
  renderSearchDropDown,
  renderSearchMultipleDropdown,
} from '../../common/form/FieldHelper';

import { TAX_EXEMPT_TYPE } from '../../../constants/constant_doc_types';
import { fetchDropdown } from '../../../actions/actionCreators';

const TaxExemptTypeDropdown = ({
  form,
  multiple,
  name,
  onPostChange,
  searchFn,
  preload = true,
}) => (
  <div className="field">
    <Field
      {...this.props}
      component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
      dropdownType={TAX_EXEMPT_TYPE}
      formId={form}
      name={name}
      onPostChange={onPostChange}
      preload={preload}
      searchFn={searchFn}
      type={TAX_EXEMPT_TYPE}
      valueField="id"
    />
  </div>
);

export default connect(
  undefined,
  { searchFn: fetchDropdown },
)(TaxExemptTypeDropdown);
